import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import Select from 'modules/core/components/Select'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

interface Props {
  loading: boolean
  form: Form
  onSubmit: (closePortal: ClosePortalFn) => Promise<void>
  onClose: () => void
}

const WORKFLOW_OPTIONS = () => [
  {
    label: i18n.t('processes.common.tag.onboarding'),
    value: 'onboarding',
  },
  {
    label: i18n.t('processes.common.tag.offboarding'),
    value: 'offboarding',
  },
  { label: i18n.t('processes.common.tag.custom'), value: 'custom' },
]

export default function NewWorkflowSurveyModal({ loading, form, onSubmit, onClose }: Props) {
  const [disabled, setDisabled] = React.useState<boolean>(false)
  const [name, setName] = React.useState<string>('')

  useEffect(() => {
    setDisabled(!form.get('name').value || loading)
  }, [loading])

  useEffect(() => {
    if (form.get('category').value == '') {
      form.get('category').set(WORKFLOW_OPTIONS()[0]?.value)
    }
  }, [])

  return (
    <Modal
      title={i18n.t('surveys.creation.workflow_survey_create.title')}
      description={i18n.t('surveys.new.description')}
      illustration="surveys"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={disabled} submit>
          {i18n.t('surveys.new.submit')}
        </Button>
      }
    >
      <FormRow>
        <Text
          mandatory
          label={i18n.t('surveys.creation.workflow_survey_create.name')}
          field={form.get('name')}
          placeholder={name || i18n.t('surveys.creation.workflow_survey')}
          onChange={(value) => {
            setDisabled(!value.value)
            setName(value.value)
          }}
          readonly={loading}
        />
      </FormRow>
      <FormRow>
        <Select
          onChange={(value) => {
            form.get('category').set(value)
          }}
          label={i18n.t('surveys.creation.workflow_survey_create.type')}
          options={WORKFLOW_OPTIONS()}
          readonly={loading}
        />
      </FormRow>
    </Modal>
  )
}
